import React from 'react'

type Props = {}

const BetdailyAppStepFourIcon = (props: Props) => {
  return (
    <svg
    width={48}
    height={48}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g filter="url(#filter0_b_702_26)">
      <circle cx={24} cy={24} r={24} fill="url(#paint0_linear_702_26)" />
      <circle cx={24} cy={24} r={24} fill="url(#paint1_linear_702_26)" />
    </g>
    <g clipPath="url(#clip0_702_26)">
      <path
        d="M28.1948 19.904C28.1948 19.7724 28.1501 19.6574 28.0646 19.5709C27.9795 19.4854 27.8655 19.4403 27.735 19.4403H27.2949C27.149 19.4403 27.034 19.4675 26.9436 19.5235C26.8625 19.5739 26.7803 19.6581 26.6939 19.7774L19.9035 28.7884C19.8401 28.8683 19.8082 28.9588 19.8082 29.0572C19.8082 29.1925 19.8575 29.3095 19.9505 29.3956C20.0389 29.4775 20.1536 29.5209 20.2818 29.5209H20.7218C20.8714 29.5209 20.989 29.4898 21.0814 29.4255C21.1563 29.3731 21.2342 29.2952 21.3226 29.1839L28.0991 20.1728C28.1616 20.0939 28.1944 20.0011 28.1944 19.904H28.1948Z"
        fill="white"
      />
      <path
        d="M19.9025 24.1532C20.2798 24.5032 20.7961 24.6808 21.437 24.6808C22.0778 24.6808 22.5957 24.5035 22.9776 24.1538C23.3618 23.8018 23.5718 23.313 23.6017 22.7024C23.6204 22.3806 23.6296 22.1771 23.6296 22.0813C23.6296 21.9766 23.6204 21.7598 23.602 21.4204C23.5725 20.8022 23.3717 20.3014 23.0049 19.9315C22.6358 19.5593 22.1084 19.3707 21.4373 19.3707C20.7662 19.3707 20.2404 19.5597 19.8756 19.9325C19.5141 20.3021 19.3159 20.8026 19.2863 21.4191C19.2771 21.5871 19.2722 21.8102 19.2722 22.0813C19.2722 22.3342 19.2768 22.5433 19.2863 22.7008C19.3163 23.3126 19.5236 23.8015 19.9029 24.1532H19.9025ZM20.6315 21.497C20.6472 21.2467 20.7199 21.0425 20.8533 20.8725C20.9732 20.7194 21.1642 20.6451 21.4373 20.6451C21.7104 20.6451 21.9049 20.7204 22.0298 20.8745C22.1665 21.0442 22.2408 21.248 22.2569 21.4966C22.275 21.7886 22.2839 21.9759 22.2839 22.0538C22.2839 22.1042 22.2747 22.2954 22.2569 22.6219C22.2323 22.8718 22.1557 23.074 22.0226 23.24C21.9023 23.3895 21.711 23.4621 21.4373 23.4621C21.1635 23.4621 20.9772 23.3885 20.8618 23.2367C20.7333 23.068 20.6558 22.8609 20.6315 22.6212C20.6226 22.4608 20.6183 22.2699 20.6183 22.0535C20.6183 21.837 20.6229 21.6392 20.6318 21.497H20.6315Z"
        fill="white"
      />
      <path
        d="M28.1201 24.7998C27.7511 24.4276 27.2236 24.239 26.5525 24.239C25.8815 24.239 25.3553 24.4279 24.9908 24.8008C24.6293 25.1704 24.4312 25.6712 24.4016 26.2884C24.3832 26.6566 24.3737 26.8929 24.3737 26.9913C24.3737 27.0898 24.3832 27.2807 24.4013 27.5551C24.4308 28.1647 24.6369 28.6635 25.0129 29.0377C25.3908 29.4139 25.9087 29.6045 26.5522 29.6045C27.1957 29.6045 27.7149 29.4142 28.0975 29.0384C28.4787 28.6638 28.687 28.165 28.7169 27.5568C28.7357 27.2343 28.7449 27.0311 28.7449 26.9357C28.7449 26.8402 28.7357 26.6287 28.7173 26.2887C28.6877 25.6709 28.4869 25.1697 28.1201 24.7998ZM27.3722 27.4902C27.3475 27.7401 27.2709 27.9423 27.1378 28.1083C27.0176 28.2578 26.8263 28.3304 26.5525 28.3304C26.2788 28.3304 26.0885 28.2562 25.9685 28.103C25.8351 27.9333 25.7625 27.7335 25.7467 27.4942C25.7378 27.3334 25.7332 27.1362 25.7332 26.9082C25.7332 26.6801 25.7378 26.5071 25.7467 26.3652C25.7628 26.115 25.8351 25.9108 25.9685 25.7408C26.0885 25.5877 26.2794 25.5134 26.5525 25.5134C26.8256 25.5134 27.0202 25.5887 27.1451 25.7428C27.2818 25.9125 27.3561 26.1163 27.3722 26.3649C27.3902 26.6566 27.3994 26.8392 27.3994 26.9082C27.3994 26.9678 27.3902 27.1637 27.3725 27.4902H27.3722Z"
        fill="white"
      />
      <path
        d="M36.1547 22.2055C35.5865 21.8008 34.942 21.3424 34.8175 20.9553C34.6827 20.5367 34.9423 19.7584 35.1714 19.072C35.5178 18.0343 35.8757 16.9614 35.3262 16.1997C34.7711 15.4304 33.6413 15.4437 32.5485 15.4566C31.8361 15.4652 31.0283 15.4745 30.6835 15.2216C30.3463 14.974 30.1091 14.2034 29.9 13.5236C29.5737 12.463 29.2362 11.3665 28.3272 11.0689C27.4533 10.7829 26.5617 11.4511 25.6994 12.0977C25.1147 12.5359 24.4522 13.0327 24.0003 13.0327C23.5485 13.0327 22.8859 12.5359 22.3013 12.0977C21.4389 11.4514 20.5473 10.7829 19.6735 11.0689C18.7645 11.3665 18.4269 12.4633 18.1006 13.5236C17.8913 14.2034 17.654 14.974 17.3171 15.2216C16.9724 15.4745 16.1646 15.4652 15.4521 15.4566C14.3594 15.4437 13.2295 15.4304 12.6745 16.1997C12.125 16.9614 12.4829 18.0343 12.8292 19.072C13.0583 19.7584 13.3179 20.5367 13.1832 20.9556C13.0586 21.3428 12.4145 21.8011 11.846 22.2058C10.9383 22.8515 10 23.5194 10 24.5001C10 25.4809 10.9383 26.1491 11.8453 26.7947C12.4135 27.1994 13.058 27.6578 13.1825 28.0449C13.3173 28.4636 13.0577 29.2418 12.8286 29.9282C12.4822 30.966 12.1243 32.0389 12.6738 32.8005C13.2289 33.5698 14.3591 33.5566 15.4515 33.5437C16.1639 33.5354 16.9717 33.5258 17.3165 33.7786C17.6537 34.0262 17.8909 34.7969 18.1 35.4767C18.4263 36.5373 18.7638 37.6337 19.6728 37.9313C19.8158 37.9781 19.9591 37.9993 20.103 37.9993C20.8378 37.9993 21.5796 37.4431 22.3006 36.9025C22.8853 36.4644 23.5478 35.9675 23.9997 35.9675C24.4515 35.9675 25.1141 36.4644 25.6987 36.9025C26.5611 37.5489 27.4527 38.2177 28.3265 37.9313C29.2355 37.6337 29.5731 36.5369 29.8994 35.4767C30.1087 34.7969 30.346 34.0262 30.6829 33.7786C31.0276 33.5258 31.8354 33.535 32.5479 33.5437C33.6406 33.5566 34.7705 33.5698 35.3255 32.8005C35.875 32.0389 35.5171 30.966 35.1708 29.9282C34.9417 29.2418 34.6821 28.4636 34.8168 28.0446C34.9414 27.6575 35.5855 27.1991 36.154 26.7944C37.0614 26.1484 37.9997 25.4805 37.9997 24.4995C37.9997 23.5184 37.0614 22.8505 36.1544 22.2048L36.1547 22.2055ZM32.1831 24.5001C32.1831 29.0509 28.5122 32.7532 24 32.7532C19.4878 32.7532 15.8169 29.0509 15.8169 24.5001C15.8169 19.9494 19.4878 16.2471 24 16.2471C28.5122 16.2471 32.1831 19.9494 32.1831 24.5001Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        id="filter0_b_702_26"
        x={-4150}
        y={-4150}
        width={8348}
        height={8348}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation={2075} />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_702_26"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_backgroundBlur_702_26"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_702_26"
        x1={0}
        y1={0}
        x2={47.0669}
        y2={2.39871}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6F6DE6" />
        <stop offset={0.489583} stopColor="#5451D4" />
        <stop offset={1} stopColor="#312DB9" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_702_26"
        x1={24}
        y1={0}
        x2={24}
        y2={48}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B21318" />
        <stop offset={1} stopColor="#7D0204" />
      </linearGradient>
      <clipPath id="clip0_702_26">
        <rect
          width={28}
          height={27}
          fill="white"
          transform="translate(10 11)"
        />
      </clipPath>
    </defs>
  </svg>
  )
}

export default BetdailyAppStepFourIcon